/**
 * Retrieves the value of a cookie by name
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
  // Debug: Log all cookies to help troubleshoot
  console.debug('All cookies:', document.cookie)

  if (!document.cookie) {
    console.debug(`No cookies found when looking for: ${name}`)
    return null
  }

  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  console.debug(`Looking for cookie: ${name}`, { parts, foundParts: parts.length })

  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(';').shift() || null
    console.debug(`Found cookie ${name}:`, cookieValue)
    return cookieValue
  }

  console.debug(`Cookie ${name} not found`)
  return null
}

/**
 * Removes a cookie by setting its expiration date to the past
 * @param name - The name of the cookie to remove
 * @param path - The path of the cookie (should match the path used when setting)
 */
export const removeCookie = (name: string, path = '/'): void => {
  document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}

/**
 * Retrieves and removes a cookie
 * @param name - The name of the cookie to fetch and remove
 * @param path - The path of the cookie (should match the path used when setting)
 * @returns The value of the removed cookie or null if not found
 */
export const popCookie = (name: string, path = '/'): string | null => {
  const value = getCookie(name)
  if (value !== null) {
    removeCookie(name, path)
  }
  return value
}
